export enum WalletFilterType {
  all = "",
  fiat = "fiat",
  crypto = "crypto",
}
